<template>
  <div class="robot-panel flex flex-column">
    <chat-header
      :show-type="props.showType"
      :style-config="page.robotStyle"
      :round="page.msgRound"
      :agentEnable="page.agentEnable"
      @switch="changeSwitch"
      @comment="openComment"
    />
    <chat-msg
      ref="chatMsgRef"
      :style-config="page.robotStyle"
      :chat-msg="chatMsg"
      :show-type="props.showType"
      :orgId="props.appInfo.orgId"
      :chatId="page.chatId"
      :btnLoading="page.btnLoading"
      @loadHistory="getChatMsgHistory"
      @sendMsg="sendRobotMsg"
      @quickAccess="handleQuickPhrase"
      @switch="changeSwitch"
      @comment="openComment"
      @comentResult="handleCommentResult"
    />
    <chat-input
      :style-config="page.robotStyle"
      :orgId="props.appInfo.orgId"
      :show-type="props.showType"
      :cust-info="custInfo"
      @sendMsg="sendRobotMsg"
      @comment="openComment"
      @quickPhrase="handleQuickPhrase"
      ref="chatInputRef"
    />
    <chat-comment
      :styleConfig="page.robotStyle"
      :orgId="props.appInfo.orgId"
      :chatId="page.chatId"
      :show-type="props.showType"
      ref="chatCommentRef"
    />
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import ChatHeader from './ChatHeader.vue'
import ChatMsg from './ChatMsg.vue'
import ChatComment from './ChatComment.vue'
import ChatInput from './ChatInput.vue'
import { defineProps, reactive, getCurrentInstance, defineEmits, nextTick, defineExpose, ref, computed } from 'vue'
import { isJSON, isMobile } from '@/utils/index'
const { proxy } = getCurrentInstance()
const emit = defineEmits(['switch'])
const props = defineProps({
  showType: { type: Number, default: 1 },
  appInfo: { type: Object, default: () => {} },
  custInfo: { type: Object, default: () => {} },
  serviceStyle: { type: Object, default: () => {} }, //在线客服样式
})
const query = reactive({
  openTime: new Date().getTime(),
  pageNo: 0,
  pageSize: 20
})
const page = reactive({
  isSend: false,
  btnLoading: false,
  msgList: [], //聊天记录
  loading: 0,
  msgRound: 0, //消息回合
  robotStyle: {}, //机器人样式
  source: null, //机器人会话来源
  chatId: null, //机器人会话id
  agentEnable: null, //是否同时接入人工
  robotId: null, //接入机器人id
  firstGreet: true  //是否首次进入
})
const chatMsg = computed(() => {
  return {
    loading: page.loading,
    list: page.msgList
  }
})
// 发送机器人消息
const sendRobotMsg = async (msg) => {
  if (props.showType === 2) return
  let data = {
    orgId: props.appInfo.orgId,
    userId: props.custInfo.custId,
    source: page.source
  }
  if (msg.type === 101) {
    data.message = msg.content
  } else if (msg.type === 102) {
    data.guessAsk = msg.content
    data.message = msg.content.label
    delete data.guessAsk.label
  }
  data.askType = msg.type
  data.avatar = page.robotStyle.avatar
  if (!page.isSend) {
    page.btnLoading = true
    page.isSend = true
    page.msgList.push({
      ...msg,
      value: 3, //客户消息
      type: 1,
      text: msg.type === 102 ? msg.content.question : msg.content,
      time: msg.timestamp || new Date().getTime(),
      headePortrait: props.custInfo.custAvatar || ''
    })
    scrollToBottom()
    try {
      let res = await proxy.$http.post('/textrobot/app/chat', data)
      if (res.code === 0) {
        page.msgRound += 1
        // 文本
        let data = res.data
        if ([1, 2].includes(data.type) && data.content) {
          if (!data.transfer) {
            page.msgList.push({
              ...data,
              value: 2,
              isAi:data.isAi,
              time: data.timestamp || new Date().getTime(),
              headePortrait: page.robotStyle?.avatar || '',
              text: data.content,
              type: 1,
              knowledge: data.knowledge
            })
          } else {
            // 转人工
            if (!data.transfer.kefuGroups) {
              changeSwitch({
                type: 11,
                word: data.transfer.word,
                groupId: data.transfer.groupId,
                transferType: 1
              })
            } else {
              // 转人工组
              page.msgList.push({
                ...data,
                value: 2,
                time: data.timestamp || new Date().getTime(),
                headePortrait: page.robotStyle?.avatar || '',
                text: data.content,
                transfer: data.transfer.kefuGroups,
                type: 9,
                knowledge: data.knowledge
              })
            }
          }
        }
        // 猜你想问
        if (data.type === 2 && data?.guessAsks.length > 0) {
          let arr = data.guessAsks.map((i) => {
            i.label = i.question
            return i
          })

          page.msgList.push({
            value: 2,
            time: data.timestamp || new Date().getTime(),
            headePortrait: page.robotStyle?.avatar || '',
            quick_replies: arr,
            isAi: data.isAi,
            type: 8,
            knowledge: data.knowledge
          })
          arr = null
        }
        // 关联问题列表
        if (data?.relatives?.length > 0) {
          let arr = data.relatives.map((i) => {
            i.label = i.question
            return i
          })

          page.msgList.push({
            value: 2,
            time: data.timestamp || new Date().getTime(),
            headePortrait: page.robotStyle?.avatar || '',
            quick_replies: arr,
            isAi: data.isAi,
            type: 8,
            knowledge: data.knowledge
          })
          arr = null
        }
        // 机器人沉默提醒
        if (page.robotStyle.triggerNum === 2) {
          handleRobotRemind()
        }
        // 滚动条最底
        scrollToBottom()
      } else {
        ElMessage.error(res.msg)
      }
      page.isSend = false
      page.btnLoading = false
    } catch (e) {
      console.log(e)
    }
  }
}
// 滚动到最底部
const chatMsgRef = ref(null)
const scrollToBottom = () => {
  chatMsgRef.value && chatMsgRef.value.scrollToBottom()
}
// 转人工
const changeSwitch = (data) => {
  let params = {
    type: data.type,
    orgId: props.appInfo.orgId,
    userId: props.custInfo.custId,
    source: page.source,
    dialogueId: page.chatId,
    word: data?.word
  }
  if (data.type === 9 && data?.knowledge && Object.keys(data?.knowledge).length > 0) {
    params.knowledgeId = data.knowledge.id
    params.knowledgeType = data.knowledge.name
  }
  let switchdata = {} //转接数据
  if (data.type === 11) {
    switchdata.groupId = data.groupId //转接客服组id
  }
  proxy.$http.post('/textrobot/app/transfer/click', params).finally(() => {
    switchdata.transferType = data.transferType ?? 2 //转接类型
    emit('switch', switchdata)
    switchdata = null
    params = null
  })
  // 清除定时器
  handleClearTimer()
}
// 机器人沉默提醒
let timer = null
const handleRobotRemind = () => {
  handleClearTimer()
  let timeout = page.robotStyle?.timeout * 1000 || 1000
  timer = setTimeout(() => {
    // 发送提醒消息
    page.msgList.push({
      value: 2, //客服消息
      type: 1,
      text: page.robotStyle?.remindWords,
      time: new Date().getTime(),
      headePortrait: page.robotStyle?.avatar
    })
    scrollToBottom()
  }, timeout)
}
const handleClearTimer = () => {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
}
// 机器人快捷短语、快捷入口点击
const handleQuickPhrase = async (data) => {
  let params = {
    dialogueId: page.chatId,
    menuId: data.id,
    orgId: props.appInfo.orgId,
    source: page.source,
    type: data.menuType,
    userId: props.custInfo.custId
  }
  await proxy.$http.post('/textrobot/app/menu/click', params)
  let type = parseInt(data.action)
  if (type === 0) {
    // 发送文本
    sendRobotMsg({ content: data.content, type: 101 })
  } else if (type === 1) {
    // 跳转外链
    window.open(data.content, '_blank')
  } else if (type === 4) {
    // 转人工
    changeSwitch({ type: 0, transferType: 2 })
  } else {
    ElMessage.info('该功能暂未开通')
  }
  params = null
}
// 获取历史消息
const getChatMsgHistory = (callback) => {
  return new Promise((resolve) => {
    if (page.loading !== 0) return
    page.loading = 1
    query.pageNo++
    let params = {
      orgId: props.appInfo.orgId,
      appId: props.appInfo.appId,
      custId: props.custInfo.custId,
      lastMsgDate: query.openTime,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    }
    proxy.$http
      .post('/app/custClient/chatmsg/history', params)
      .then((res) => {
        if (res.code === 0) {
          let { list, currPage, totalCount } = res.data
          if (currPage === Math.ceil(totalCount / query.pageSize) || list.length === 0) {
            page.loading = 2
          } else {
            page.loading = 0
          }
          list.forEach((item) => {
            let obj = {
              ...item,
              value: item.toType + 1,
              type: item.msgContentType,
              text: item.content,
              time: item.timestamp,
              headePortrait: item.fromHeadImg || '',
              obj: isJSON(item.content) ? JSON.parse(item.content) : {}
            }
            // 需要特殊处理的系统消息
            if (obj.type == 20) {
              if (item.systemMsgType === 4) { 
                obj.value = 2
              } else {
                obj.value = 5
              }
            }
            page.msgList.push(obj)
          })
          if (callback) {
            nextTick(() => {
              callback(list.length)
            })
          }
          resolve(list.length)
        } else {
          ElMessage.error(res.msg)
        }
      })
      .catch((e) => {
        page.loading = 0
        ElMessage.error('网络连接异常，请稍候再试')
      })
  })
}
// 发送机器人消息(欢迎语，置顶问题)
const handleSendRobotMsg = () => {
  // 发送欢迎语
  let id = props.custInfo.custId
  let robotGreet = localStorage.getItem("robotGreet");
  if (
    (page.robotStyle?.greet?.content !== '<p><br></p>' && page.robotStyle.greet?.sendType === 1) ||
    (page.robotStyle.greet?.sendType === 2 && !page.firstGreet)
  ) {
    page.msgList.push({
      value: 2,
      type: 1,
      text: page.robotStyle?.greet?.content || '您好，请问有什么可以帮助您？',
      time: new Date().getTime(),
      headePortrait: page.robotStyle?.avatar || ''
    })
  }
  // 发送常见置顶问题
  if (page.robotStyle.topQuestion && page.robotStyle.showGuide && page.robotStyle.topQuestion.length > 0) {
    if (page.robotStyle?.sendTime === 1 || (page.robotStyle?.sendTime === 2 && !id)) {
      page.msgList.push({
        value: 2,
        type: 7,
        time: new Date().getTime(),
        headePortrait: page.robotStyle?.avatar || '',
        quick_replies: page.robotStyle.topQuestion
      })
    }
  }
  scrollToBottom()
  // 沉默提醒
  if (page.robotStyle?.remind) {
    handleRobotRemind()
  }
}
const chatInputRef = ref(null)
// 初始化机器人
const initRobot = async () => {
  let params = {
    orgId: props.appInfo.orgId,
    userId: props.custInfo.custId,
    robotId: page.robotId,
    fromType: 0,
    configs: [
      'TEXTROBOT_BASIC_SET',
      'TEXTROBOT_COMMENT_PROBLEM',
      'TEXTROBOT_QUICK_PHRASE',
      'TEXTROBOT_QUICK_ACCESS',
      'TEXTROBOT_ANSWER_SATISFACTION',
      'TEXTROBOT_SESSION_SATISFACTION',
      'TEXTROBOT_TRANSFER_SERVICE',
      'TEXTROBOT_SILENCE_REMIND'
    ]
  }
  let res = await proxy.$http.post('/textrobot/app/robotInit', params)
  if (res.code === 0) {
    let data = res.data || {}
    if (data.allot === 1) {
      // 转在线客服
      emit('switch', {})
      return
    }
    if (!data.allot || data.allot?.robotId === null) {
      return ElMessage.error('获取不到机器人信息')
    }
    page.firstGreet = localStorage.getItem("robotId") === data.allot.robotId
    // 缓存机器人id
    localStorage.setItem('robotId', data.allot.robotId)
    page.agentEnable = data.allot.type === 0 ? true : false
    nextTick(() => {
      chatInputRef.value?.getRobotAssociate()
    })

    page.chatId = data.chatEntity.id
    let flag = isMobile()
    if (!flag) {
      page.source = 3
    } else {
      page.source = ['iPhone'].includes(flag[0]) ? 1 : 2
    }
    let phraseList = [],
      commonQa = []
    // 常见问题
    if (data?.questionEntities) {
      commonQa = data.questionEntities.map((i) => {
        i.label = i.knowledgeName
        return i
      })
    }
    // 快捷短语
    if (data?.rapidPhraseEntities) {
      phraseList = res.data.rapidPhraseEntities
    }
    let info = {}
    for (let key in data.configs) {
      info[key] = isJSON(data.configs[key]) ? JSON.parse(data.configs[key]) : {}
    }
    page.robotStyle = {
      phraseList: phraseList,
      avatar: info['TEXTROBOT_BASIC_SET']?.avatar,
      nickname: info['TEXTROBOT_BASIC_SET']?.nickname,
      greet: info['TEXTROBOT_BASIC_SET']?.greet,
      guide: info['TEXTROBOT_BASIC_SET']?.guide || { content: '您是想问？' },
      showGuide: info['TEXTROBOT_COMMENT_PROBLEM']?.showGuide,
      guideWords: info['TEXTROBOT_COMMENT_PROBLEM']?.guideWords,
      sendTime: info['TEXTROBOT_COMMENT_PROBLEM']?.sendTime,
      display: info['TEXTROBOT_COMMENT_PROBLEM']?.display,
      topQuestion: commonQa,
      ...info['TEXTROBOT_QUICK_PHRASE'],
      ...info['TEXTROBOT_QUICK_ACCESS'],
      ...info['TEXTROBOT_ANSWER_SATISFACTION'],
      ...info['TEXTROBOT_SESSION_SATISFACTION'],
      transferEntry: info['TEXTROBOT_TRANSFER_SERVICE']?.transferEntry,
      transferEntryForm: info['TEXTROBOT_TRANSFER_SERVICE']?.transferEntryForm,
      negativeComment: info['TEXTROBOT_TRANSFER_SERVICE']?.negativeComment,
      ...info['TEXTROBOT_SILENCE_REMIND']
    }
    // 机器人主题设置设置为人工主题样式
    if (props.serviceStyle && props.serviceStyle.styleConfig) {
      page.robotStyle.styleConfig = props.serviceStyle.styleConfig
    }
    // 快捷入口加入快捷短语
    if (page.robotStyle?.transferEntry && page.robotStyle?.transferEntryForm?.showType === 2) {
      page.robotStyle.phraseList.unshift({
        name: '转人工',
        action: 4,
        id: new Date().getTime()
      })
    }
    // 发送欢迎语
    if (page.pageStatus !== 2) {
      handleSendRobotMsg()
    }
    phraseList = null
    commonQa = null
    info = null
    data = null
  } else {
    ElMessage.error(res.msg)
  }
}
// 初始化
const init = (robotId) => {
  // 设置转接机器人id
  page.robotId = robotId
  // 重置机器人数据
  page.chatId = null
  page.source = null
  page.msgRound = 0
  // 初始化机器人
  initRobot()
  // 加载历史消息
  page.msgList = []
  page.loading = 0
  query.openTime = new Date().getTime()
  query.pageNo = 0
  getChatMsgHistory().then(() => {
    scrollToBottom()
  })
}
// 评价
const chatCommentRef = ref(null)
const openComment = () => {
  chatCommentRef.value.open()
}


/**
 * 差评转人工
 * @param data
 */
 const handleCommentResult = (data) => {
  changeSwitch(data.transfer)
}

defineExpose({
  init
})
</script>

<style lang="less" scoped>
.robot-panel {
  width: 100%;
  height: 100%;
  background: #f0f1f2;
  overflow: hidden;
}
</style>
